<template>
  <div class="scene" id="scene-2" :class="{ expanded: expanded }">
    <ImageFloat
      id="letter-image"
      className="letter-image"
      :class="{
        'fix-me': activeElements['letter-image'] === 'fixed',
        'end': activeElements['letter-image'] === 'end'
      }"
    />
    <Letter
      id="letter-view"
      :class="{
        'fix-me': activeElements['letter-view'] === 'fixed',
        'end': activeElements['letter-view'] === 'end'
      }"
    />
    <div id="trigger-3" class="triggers"></div>
    <div id="trigger-4" class="triggers"></div>
    <PopFloat
      id="letter-pop"
      :letter="true"
      @showingfull="expand"
    />
    <div id="trigger-5" class="triggers"></div>
  </div>
</template>

<script>
import Letter from '@/components/Letter.vue'
import ImageFloat from '@/components/ImageFloat.vue'
import strings from '@/data/strings.json'
import PopFloat from '@/components/PopFloat.vue'
import senseScroll from '@/utils/senseScroll.js'

export default {
  name: 'SceneTwo',
  data () {
    return {
      page: {},
      inside: false,
      strings: strings,
      expanded: false,
      directives: [
        {
          id: 'letter-image',
          start: 'scene-2',
          end: 'trigger-5'
        },
        {
          id: 'letter-view',
          start: 'scene-2',
          end: 'trigger-4'
        }
      ]
    }
  },
  props: {
    scrollPos: Number
  },
  computed: {
    activeElements () {
      let self = this
      return senseScroll(self.directives, self.scrollPos)
    },
    mobilePercentOfJourney () {
      let start = this.offset(this.directives[0].start)
      let end = this.offset(this.directives[0].end)
      return ((start.top - this.scrollPos) / (start.top - end.top)) * 100
    }
  },
  watch: {
  },
  methods: {
    expand (va) {
      this.expanded = va
    }
  },
  mounted () {
  },
  components: {
    Letter,
    ImageFloat,
    PopFloat
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  #scene-2 {
    height: 330vh;
    position: relative;
    &.expanded {
      height: 390vh;
    }
  }
  .ani {
    opacity: 1;
    transition: opacity 0.2s ease;
    &.fix-me, &.end {
      opacity: 1;
    }
  }
  .letter-image, #letter-view {
    position: absolute;
    width: 100%;
    height: 100vh;
    top: 0px;
  }
  .letter-image {
    background-image: url('../assets/new/letter-min.png');
    background-size: auto 70%;
    background-position: 50% 50%;
    background-repeat: no-repeat;
  }
  .letter-image.end, #letter-pop, #trigger-3 {
    position: absolute;
    top: 200vh;
  }
  #trigger-4, #letter-view.end {
    position: absolute;
    width: 100%;
    top: 130vh;
  }
  #letter-pop.end, .stop, #trigger-5 {
    position: absolute;
    width: 100%;
    top: 200vh;
  }
  .fix-me {
    top: 0px;
    position: fixed !important;
  }
  .triggers {
    position: absolute;
    height: 100vh;
    width: 100%;
  }
</style>
